import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import {  DocumentCategory } from '../../../../../../../graphql'

const videoExtensions = ['mpg', 'mp2', 'mpeg', 'mpe', 'mpv', 'mp4', 'webm', 'ogg', 'avi', 'flv'] 
const imageExtensions = ['gif', 'jpg', 'jpeg', 'png', 'webp', 'svg']

@Component({
    selector: 'app-listing-documents',
    templateUrl: 'listing-documents.html'
})
export class ListingDocumentsComponent {

    documents: [DocumentCategory]
    documentsCategorised = {}

    constructor(@Inject(MAT_DIALOG_DATA) public data: {documents: [DocumentCategory]}) {
        this.documents = data.documents
    }

    formatName(name: string) {
        const decodedString = decodeURIComponent(name)
        const parts = decodedString.split(/_(.*)/s)
        return parts.length > 1 ? parts[1] : parts[0]
    }

    isMediaFile(file: string) {
        const fileExt = file.split('.')[1]
        return videoExtensions.indexOf(fileExt) > -1 || imageExtensions.indexOf(fileExt) > -1
    };
}
